let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("h0uBE"), load("1n8w9"), load("eBLgB"), load("fjrny")]).then(() => parcelRequire('dhWIx'));